import { __exports as a } from "../../../../../../../../_virtual/sanitizer.js";
import { b as n } from "../../../../../../isomorphic-dompurify@2.26.0_canvas@3.2.0/bundled_deps/isomorphic-dompurify/browser.js";
import "./custom-sanitizers.js";
import "./config/index.js";
import { __exports as u } from "../../../../../../../../_virtual/custom-sanitizers.js";
import { __exports as s } from "../../../../../../../../_virtual/index2.js";
Object.defineProperty(a, "__esModule", {
  value: !0
});
a.sanitizeHtml = f;
var o = r(n), i = r(u), m = r(s);
function r(t) {
  return t && t.__esModule ? t : { default: t };
}
o.default.addHook("uponSanitizeElement", function(t, e) {
  i.default[t.tagName] && i.default[t.tagName](t, e);
});
function f(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return o.default.sanitize(t, (0, m.default)(e.config));
}
export {
  a as default
};
